import CityPageTemplate from "../city-template/CityPageTemplate";
import { homerConfig } from "./data";

export default function HomerPage() {
  return <CityPageTemplate config={homerConfig} />;
}